import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submit", "widget"];

  connect() {
    this.submitTarget.disabled = true;

    // We must ensure turnstile is loaded before trying to render.
    if (typeof turnstile === "undefined") {
      let retries = 0;
      const interval = setInterval(() => {
        if (typeof turnstile !== "undefined") {
          clearInterval(interval);
          this.renderTurnstile();
        }
        retries++;
        if (retries > 50) clearInterval(interval); // Timeout after 5s
      }, 100);
    } else {
      this.renderTurnstile();
    }
  }

  renderTurnstile() {
    try {
      const targetElement = this.hasWidgetTarget ? this.widgetTarget : this.element;
      const sitekey = targetElement.dataset.sitekey || document.querySelector('meta[name="turnstile-site-key"]')?.content;
      
      if (!sitekey) {
        console.warn("Turnstile sitekey not found");
        return;
      }
      
      this.widgetId = turnstile.render(targetElement, {
        sitekey: sitekey,
        theme: targetElement.dataset.theme || "auto",
        size: targetElement.dataset.size || "normal",
        callback: (token) => {
          this.submitTarget.disabled = false;
        },
        "error-callback": () => {
          this.submitTarget.disabled = true;
        },
        "expired-callback": () => {
          this.submitTarget.disabled = true;
        }
      });
    } catch (e) {
      console.error("Turnstile render error", e);
    }
  }

  disconnect() {
    if (this.widgetId !== undefined && typeof turnstile !== "undefined") {
      turnstile.remove(this.widgetId);
      this.widgetId = undefined;
    }
  }
}
